import axios from 'axios'
import { getToken } from '../utils/tokens';

const instance = axios.create();
instance.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
instance.defaults.timeout = 10000; // 10 seconds
instance.defaults.headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    // 'token': getToken('AUTHORIZATION_TOKEN_BLOG'),
    // 'refresh': getToken('REFRESH_TOKEN_BLOG')
}

// Read token fresh on every request
instance.interceptors.request.use(config => {
    config.headers['token'] = getToken('AUTHORIZATION_TOKEN_BLOG');
    config.headers['refresh'] = getToken('REFRESH_TOKEN_BLOG');
    return config;
});

// Handle expired/invalid token globally
instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('AUTHORIZATION_TOKEN_BLOG');
            localStorage.removeItem('REFRESH_TOKEN_BLOG');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default instance;
